import { render, staticRenderFns } from "./filterCategory.vue?vue&type=template&id=ad67dec8&scoped=true&"
import script from "./filterCategory.vue?vue&type=script&lang=js&"
export * from "./filterCategory.vue?vue&type=script&lang=js&"
import style0 from "./filterCategory.vue?vue&type=style&index=0&id=ad67dec8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad67dec8",
  null
  
)

export default component.exports